$(document).ready(function() {
  if ($("#createSubscriptionShortcut").length === 0) {
    return ;
  }

  $("#profiles, #funds").on("change", function() {
    let $button = $("#linkToSubscription");
    let template_url = $button.data("url");

    let $profileInput = $("#profiles");
    let $fundInput = $("#funds");

    if ($profileInput.val() === "" || $fundInput.val() === "" ) {
      $button.addClass("disabled").prop("disabled", false);
      return ;
    }

    var url = template_url.replace("-1", $fundInput.val()).replace("-2", $profileInput.val());

    $button.attr("href", url);
    $button.removeClass("disabled").prop("disabled", false);
  });
});
